import { Route, Routes } from "react-router-dom";

// Admin dashboard login
import { Login, ForgetPassword, ResetPassword, Dashboard, Welcome, Intro, Video, Rest, ThankYou,IdelScreen } from "../pages";
import UnprotectedRoute from "../pages/UnprotectedRoute";
import ProtectedRoute from "../pages/ProtectedRoute";
import IdleScreen from "../pages/preview/IdleScreen";

export const adminRoutes = {
  gym: "/",
  login: "/login",
  forgetPassword: "/forget-password",
  resetPassword: "/reset-password/:token",
  listSession:"/list-session",
  createSession:"/add-session",
  previewScreen:"/preview-screen",
  intro:"/intro",
  video:"/video",
  rest:"/rest",
  thankYou:"/thankyou",
  idleScreen:"/idle-screen"

};

const AdminRouter = () => {
  return (
    <Routes>
      <Route element={<UnprotectedRoute />}>
        <Route path={adminRoutes.login} element={<Login />} />
        <Route path={adminRoutes.forgetPassword} element={<ForgetPassword />} />
        <Route path={adminRoutes.resetPassword} element={<ResetPassword />} />
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route path={adminRoutes.gym} element={<Dashboard />} />
        <Route path={adminRoutes.idleScreen} element={<IdleScreen />} />
        <Route path={adminRoutes.previewScreen} element={<Welcome />} />
        <Route path={adminRoutes.intro} element={<Intro/>} />
        <Route path={adminRoutes.video} element={<Video/>} />
        <Route path={adminRoutes.rest} element={<Rest/>} />
        <Route path={adminRoutes.thankYou} element={<ThankYou/>} />
      </Route>
    </Routes>
  );
};

export default AdminRouter;
